import BaseApi from './base/BaseApi';
import { PutOperation, PostOperation, GetOperation } from './base/operations';

export default class extends BaseApi {
  login(params) {
    const iri = params._remember_me ? '/auth/login?_remember_me=1' : '/auth/login'; // eslint-disable-line no-underscore-dangle
    const operation = new PostOperation(iri, params);
    return this.execute(operation, true);
  }

  logout() {
    const operation = new GetOperation('/auth/logout', []);
    return this.execute(operation, true);
  }

  requestPasswordRecoveryEmail(params) {
    const operation = new PostOperation('/auth/password-recovery', params);
    return this.execute(operation, true);
  }

  resetPassword(params) {
    const operation = new PutOperation('/auth/password-recovery', params);
    return this.execute(operation, true);
  }
}
